import { render, staticRenderFns } from "./Landing2Navbar.vue?vue&type=template&id=6f59906b&scoped=true"
import script from "./Landing2Navbar.vue?vue&type=script&lang=js"
export * from "./Landing2Navbar.vue?vue&type=script&lang=js"
import style0 from "./Landing2Navbar.vue?vue&type=style&index=0&id=6f59906b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59906b",
  null
  
)

export default component.exports